export default "__VITE_ASSET__rZFhHPzQ__"